/**
 * vendor
 */
import React from 'react';
import i18n from "i18n";

/**
 * sportsbook
 */
import ROUTES from '@shared/lib/constants/routes';

/**
 * Footer Component
 */
function Footer() {
  return (
    <footer className="section footer-classic footer-classic-dark">
      <div className="footer-classic-main">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row gap-8 md:gap-12 -mx-4">
             <div className="w-full text-center md:text-left px-4">
              <div className="unit-spacing-xl">
                <article className="unit unit-sm-horizontal flex flex-col md:flex-row items-center md:justify-start md:items-start footer-classic-info gap-4">
                  <div className="unit-left flex-shrink-0">
                    {/* <!-- Brand--> */}
                    <a className="brand" href="/">
                      <img className="brand-logo-dark" src="images/logo.png" alt="" width="106" height="41"/>
                      <img className="brand-logo-light" src="images/logo.png" alt="" width="106" height="41"/>
                    </a>
                  </div>
                  <div className="unit-body flex-1">
                    <p>
                      {i18n.t('footer_info')}
                    </p>
                  </div>
                </article>
              </div>
              <div className="group-md group-middle flex flex-wrap items-center justify-center md:justify-start gap-4 mt-4">
                <div className="group-item">
                  <ul className="list-inline list-inline-xs flex flex-wrap items-center justify-center gap-3">
                    <li className="flex items-center justify-center" style={{ display: 'flex' }}>
                      <a className="icon icon-corporate fa-brands fa-facebook flex items-center justify-center" href="#" style={{ display: 'flex' }}></a>
                    </li>
                    <li className="flex items-center justify-center" style={{ display: 'flex' }}>
                      <a className="icon icon-corporate fa-brands fa-twitter flex items-center justify-center" href="#" style={{ display: 'flex' }}></a>
                    </li>
                    <li className="flex items-center justify-center" style={{ display: 'flex' }}>
                      <a className="icon icon-corporate fa-brands fa-instagram flex items-center justify-center" href="#" style={{ display: 'flex' }}></a>
                    </li>
                    <li className="flex items-center justify-center" style={{ display: 'flex' }}>
                      <a className="icon icon-corporate fa-brands fa-linkedin flex items-center justify-center" href="#" style={{ display: 'flex' }}></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-classic-aside footer-classic-darken">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            {/* <!-- Rights--> */}
            <p className="rights">
              <span>Caribe7</span>
              <span>&nbsp;&copy;&nbsp;</span>
              <span className="copyright-year"></span><span>.&nbsp;</span>
              <a className="link-underline" href="/privacy-policy">{i18n.t('privacy_policy')}</a></p>
            <nav className="nav-minimal">
              <ul className="nav-minimal-list flex flex-wrap items-center gap-4">
                <li><a href={ROUTES.HELP}>{i18n.t('help')}</a></li>
                <li><a href={ROUTES.CONTACT}>{i18n.t('contact_us')}</a></li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
